import { createContext, useContext } from 'react'

const BetContext = createContext()
BetContext.displayName = "BetContext"

export const useBet = () => useContext(BetContext)

export default BetContext
